import React, { useCallback, useContext } from 'react'
import Dropdown from 'components/Luxkit/Dropdown/v2/Dropdown'
import DualDateRangePicker from 'components/Common/Calendar/DualDateRangePicker'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import moment from 'moment'
import styled from 'styled-components'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { SearchMenuStates } from 'components/Search/type'
import { rem } from 'polished'
import { addDays, addMonths, beginningOfToday, isSameDay } from 'lib/dateUtils'
import SearchDateFooter from 'components/Search/SearchForm/SearchDateInput/SearchDateFooter'

interface Props {
  dropdownTriggerRef: React.MutableRefObject<HTMLDivElement>;
}

function findMinDate() {
  if (new Date().getHours() === 23) {
    const tomorrow = addDays(new Date(), 1)
    tomorrow.setHours(0, 0, 0, 0)
    return tomorrow
  }
  const today = beginningOfToday()
  return today
}

const minDate = findMinDate()
const maxDate = addMonths(new Date(), 18)

const DatePickerWrapper = styled.div`
  padding: ${rem(30)};
`

function CarHireDateSelect(props: Props) {
  const { checkinDate: pickUpDate, checkoutDate: returnDate } = useContext(GlobalSearchStateContext)
  const { dropdownTriggerRef } = props

  const onDatesChange = (dates: {
    startDate: moment.Moment;
    endDate: moment.Moment | null;
  }) => {
    if (dates?.startDate && isSameDay(dates.startDate.toDate(), new Date())) {
      searchDispatch({ type: GlobalSearchStateActions.UNSET_PICKUP_TIME })
    }

    if (dates?.endDate && isSameDay(dates.endDate.toDate(), new Date())) {
      searchDispatch({ type: GlobalSearchStateActions.UNSET_RETURN_TIME })
    }

    searchDispatch({ type: GlobalSearchStateActions.SET_CHECKIN_DATE, date: dates.startDate })
    searchDispatch({ type: GlobalSearchStateActions.SET_CHECKOUT_DATE, date: dates.endDate })
  }

  const clearDates = () => {
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKIN_DATE })
    searchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKOUT_DATE })
    toggleDropdown()
  }

  const { activeMenu } = useContext(GlobalSearchStateContext)
  const searchDispatch = useContext(GlobalSearchDispatchContext)

  const showDropdown = activeMenu === SearchMenuStates.CarHireDatePicker

  const toggleDropdown = useCallback(() => {
    const nextMenu = showDropdown ? SearchMenuStates.Closed : SearchMenuStates.CarHireDatePicker
    searchDispatch({ type: GlobalSearchStateActions.SET_ACTIVE_MENU, menu: nextMenu })
  }, [searchDispatch, showDropdown])

  return (
    <Dropdown
      open={showDropdown}
      triggerRef={dropdownTriggerRef}
      onClose={toggleDropdown}
      floatingStrategy="absolute"
      width="100%"
      position="bottom"
    >
      <DropdownContainer style={{ padding: 0 }}>
        <DatePickerWrapper>
          <DualDateRangePicker
            onDatesChange={onDatesChange}
            startDate={pickUpDate || null}
            endDate={returnDate || null}
            minDate={minDate}
            maxDate={maxDate}
            startLabel="Pick-up"
            endLabel="Return"
          />
        </DatePickerWrapper>

        <div>
          <SearchDateFooter onApply={toggleDropdown} onDecline={clearDates} label="day" />
        </div>
      </DropdownContainer>

    </Dropdown>
  )
}

export default CarHireDateSelect
